import SignUpDisabled from "./SignUpDisabled";

export default SignUpDisabled;